var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 17,
    viewBox: "0 0 9 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_12750)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.299391 16.2668C0.630755 16.5788 1.16666 16.5788 1.49721 16.2668L8.5033 9.65561C8.66013 9.50988 8.78501 9.33448 8.87034 9.14008C8.95567 8.94569 8.99967 8.73635 8.99967 8.52481C8.99967 8.31326 8.95567 8.10393 8.87034 7.90953C8.78501 7.71513 8.66013 7.53974 8.5033 7.39401L1.44648 0.734007C1.28633 0.585165 1.07423 0.501506 0.853282 0.50002C0.632329 0.498534 0.419081 0.579333 0.256846 0.726007C0.176477 0.798439 0.112172 0.886232 0.0679118 0.98395C0.0236517 1.08167 0.000379213 1.18723 -0.000464488 1.2941C-0.00130819 1.40097 0.0202949 1.50687 0.0630069 1.60524C0.105719 1.70362 0.168631 1.79237 0.247846 1.86601L6.70657 7.95961C6.78505 8.03248 6.84754 8.1202 6.89025 8.21743C6.93295 8.31467 6.95498 8.41939 6.95498 8.52521C6.95498 8.63103 6.93295 8.73574 6.89025 8.83298C6.84754 8.93021 6.78505 9.01794 6.70657 9.09081L0.299391 15.1364C0.220936 15.2092 0.158458 15.2969 0.115763 15.394C0.0730688 15.4912 0.0510509 15.5958 0.0510509 15.7016C0.0510509 15.8074 0.0730688 15.912 0.115763 16.0092C0.158458 16.1064 0.220936 16.194 0.299391 16.2668Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_12750"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBlack);
export default __webpack_public_path__ + "static/media/arrow-right-black.6f224b03d5ad878cc46e79f4558d8491.svg";
export { ForwardRef as ReactComponent };